import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'portal-main-nav',
  templateUrl: './main-nav.component.html',
  host: {
    class: 'main-nav',
  },
  standalone: false,
})
export class MainNavComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
